import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { sentenceCase } from "change-case";
import SectionHeading from "~/client/pages/DemoRecipePage/SectionHeading";
import { Item, ItemsList, Section } from "./styled";
const EquipmentPanel = ({ equipment }) => (_jsxs(Section, { children: [_jsx(SectionHeading, { children: "Equipment" }), _jsx(ItemsList, { children: equipment.map((item) => (_jsx(Item, { children: sentenceCase(item.item) }, item.id))) })] }));
export default EquipmentPanel;
